import {type GetterTree} from 'vuex';
import state from './state';

export default {
  isAuthenticated: state => !!state.idToken && state.authStatus,
  getTagFilters: state => state.tagFilters,
} as GetterTree<typeof state, unknown>;
